import { Box, Skeleton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@mui/material";

const KitTableSkeleton = () => {
    return (
        <>
            <TableContainer component={Paper} sx={{ backgroundColor: "#1e1e1e" }}>
                <Table>
                    {/* Table Head */}
                    <TableHead>
                        <TableRow>
                            {['Kit', 'Nº', 'Emissão', 'Devolvido', 'Ativo', 'Data Prevista', 'Valor Total', 'Pago ?', '↓', 'Editar'].map((header, index) => (
                                <TableCell key={index} sx={{ color: 'white', fontWeight: 'bold' }}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                        {[...Array(5)].map((_, rowIndex) => (
                            <TableRow key={rowIndex} sx={{ backgroundColor: rowIndex % 2 === 0 ? "#444444" : "#333333" }}>
                                <TableCell><Skeleton variant="circular" width={12} height={12} /></TableCell>
                                <TableCell><Skeleton variant="text" width={30} /></TableCell>
                                <TableCell><Skeleton variant="text" width={100} /></TableCell>
                                <TableCell><Skeleton variant="text" width={50} /></TableCell>
                                <TableCell><Skeleton variant="circular" width={12} height={12} /></TableCell>
                                <TableCell><Skeleton variant="text" width={80} /></TableCell>
                                <TableCell><Skeleton variant="text" width={70} /></TableCell>
                                <TableCell><Skeleton variant="circular" width={12} height={12} /></TableCell>
                                <TableCell>
                                    <Box
                                    sx={{display: 'flex', flexDirection: 'row', gap: '10px'}}
                                    >
                                    <Skeleton variant="rectangular" width={12} height={12} sx={{ marginX: 1 }} />
                                    <Skeleton variant="rectangular" width={12} height={12} sx={{ marginX: 1 }} />
                                    </Box>
                                </TableCell>
                                <TableCell><Skeleton variant="circular" width={12} height={12} /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, alignItems: 'center' }}>
                <Skeleton variant="text" width={100} height={20} sx={{ mr: 2 }} />
                <IconButton>
                    <Skeleton variant="circular" width={24} height={24} />
                </IconButton>
                <IconButton>
                    <Skeleton variant="circular" width={24} height={24} />
                </IconButton>
            </Box>
        </>
    );
};

export default KitTableSkeleton;